import { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Drawer from '@mui/material/Drawer';
import Grid from '@mui/material/Grid';

import '../../css/searchPage.css';
import { AllergenIcon, DietIcon, PreferencesIcon } from '../../iconRef/profilePageIcons';
import { TextPrimary } from '../typography';
import AllergenSelector from './AllergenSelector';
import DietSelector from './DietSelector';
import styles from "./userPreference.module.css";

const UserPreference = () => {
  const [drawer, setDrawer] = useState<boolean>(false);
  const [preferenceType, setPreferenceType] = useState<string>('');
  const [expanded, setExpanded] = useState<boolean>(false);

  const handlePreferenceType = (type: string) => {
    setDrawer(true);
    setPreferenceType(type);
  };

  const handleAccordionChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded);
  };

  return (
    <Grid className={styles.userPreferenceContainer}>
      <Accordion
        className={styles.accordionContainer}
        disableGutters
        expanded={expanded}
        id="preferences-accordian"
        onChange={handleAccordionChange}
        slotProps={{
          transition: {
            timeout: 0,
          },
        }}
        square>
        <AccordionSummary
          className={expanded ? styles.accordionExpanded : ''}
          expandIcon={<ExpandMoreIcon />}>
          <Grid className={styles.userPreferencesTab}>
            <PreferencesIcon />
            <TextPrimary text='Preferences' />
          </Grid>
        </AccordionSummary>
        <AccordionDetails className={styles.accordionDetails}>
          <Grid className={styles.preferncesAccordianDetails}>
            <Grid className={styles.dietOrAllergenTab} onClick={() => handlePreferenceType('diet')}><DietIcon /><TextPrimary text='Diet' /></Grid>
            <Grid className={styles.dietOrAllergenTab} onClick={() => handlePreferenceType('allergens')}><AllergenIcon /><TextPrimary text='Allergens and Dislikes' /></Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Drawer anchor='bottom' className={`filterDrawer ${styles.preferncesDrawerContainer}`} onClose={() => setDrawer(false)}
        open={drawer}>
        <Grid className={styles.preferncesDrawer}>
          {preferenceType === 'diet' ? <DietSelector setDrawer={setDrawer} /> : null}
          {preferenceType === 'allergens' ? <AllergenSelector setDrawer={setDrawer} /> : null}
        </Grid>
      </Drawer>
    </Grid>
  );
};

export default UserPreference;
